import React from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import "./Hamburger.css";

function Hamburger(prop) {
  const history = useHistory();

  const Logouthandler = () => {
    if (window.confirm("Do you really want log out?")) {
      localStorage.removeItem("token-2");

      history.push("/login");
    }
  };

  return (
    <Menu >
      <MenuButton
        as={IconButton}
        // aria-label='Options'
        icon={<HamburgerIcon />}
        variant="outline"
        style={{
          textDecoration: "none",
          background: "#867e7e83",
          color: "black",
          padding: "0.5em",
        }}
      />
      <MenuList className="menu-hamb">
        <MenuItem
          style={{ background: "gray", }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          <Link
            className="menu-hamb-link"
            style={{ textDecoration: "none" }}
            to="/admin/member"
          >
            Membership Form
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          <Link style={{ textDecoration: "none" }} to="/admin/mittiDetails">
            New Mitti
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          {/* <Link style={{ textDecoration: "none" }} to="/admin/displayDates">
            Display Dates
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        > */}

<Link style={{ textDecoration: "none" }} to="/admin/calender">
Display Dates
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray", border: "white" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >




          <Link style={{ textDecoration: "none" }} to="/admin/mittiReports">
          Mitti Report
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          <Link style={{ textDecoration: "none" }} to="/admin/allmembers">
            All Members List
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          <Link style={{ textDecoration: "none" }} to="/admin/Outstanding">
            Outstanding Reports
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray", border: "white" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          <Link
            style={{ textDecoration: "none" }}
            to="/admin/display-date-report"
          >
            Display Dates Reports
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray", border: "white" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >



          {/* <Link style={{ textDecoration: "none" }} to="/admin/calender">
         Calender wise
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray", border: "white" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        > */}
          <Link style={{ textDecoration: "none" }} to="/admin/olia">
            Olia Display
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray", border: "white" }}
          onClick={() => {
            prop.setupdate(Date.now());
          }}
        >
          <Link style={{ textDecoration: "none" }} to="/admin/setting">
            Setting
          </Link>
        </MenuItem>
        <MenuItem
          style={{ background: "gray", border: "white" }}
          onClick={Logouthandler}
        >
          <span style={{ color: "black" }}>Logout</span>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}

export default Hamburger;
